export class WebhookV1StandardPayloadRestoreJobFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobFailed",
            "baseName": "restoreJobFailed",
            "type": "WebhookV1RestoreJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
